module.exports = __webpack_public_path__ + "img/order_delivery_bike.7371c257.png";